//https://smoothprogramming.com/tutorials/how-to-protect-copyright-of-webpage-content/
document.addEventListener('contextmenu', event => event.preventDefault());
document.addEventListener('keyup', (e) => {
    if (e.key == 'PrintScreen') {
        navigator.clipboard.writeText('');
        // alert('Screenshots disabled!');
        window.clipboardData.clearData();
    }
});
